module.exports = __webpack_public_path__ + "static/media/PencilEdit.9772ea1c.svg";